module.exports = __webpack_public_path__ + "img/179993.1ada04e1.png";